"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox/Checkbox.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _excluded = ["margin"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _makeStyles.default)({
  root: function root(_ref) {
    var margin = _ref.margin;
    return {
      margin: margin,
      padding: '0px',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    };
  }
});

var CheckboxWithoutLabel = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var readOnly = props.readOnly;

  var margin = props.margin,
      radioProps = _objectWithoutProperties(props, _excluded);

  var _useStyles = useStyles({
    margin: margin
  }),
      root = _useStyles.root;

  return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
    ref: ref,
    classes: {
      root: root
    },
    checkedIcon: /*#__PURE__*/_react.default.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("rect", {
      width: "24",
      height: "24",
      rx: "4",
      fill: "#EC691A"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M10.2316 14.7177L18.2899 6.96623C18.5815 6.67792 19.0542 6.67792 19.3458 6.96623C19.6374 7.25453 19.6374 7.72195 19.3458 8.01025L10.7595 16.2838C10.4679 16.5721 9.99521 16.5721 9.70363 16.2838L5.53314 12.0706C5.24156 11.7823 5.24156 11.3148 5.53314 11.0265C5.82471 10.7382 6.29745 10.7382 6.58903 11.0265L10.2316 14.7177Z",
      fill: "white"
    })),
    icon: /*#__PURE__*/_react.default.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("rect", {
      x: "1",
      y: "1",
      width: "22",
      height: "22",
      rx: "4",
      fill: "white",
      stroke: "#A0A0A0"
    })),
    disableRipple: true,
    color: "default",
    inputProps: {
      readOnly: readOnly
    }
  }, radioProps));
});

var _default = CheckboxWithoutLabel;
exports.default = _default;